import React from 'react';
import { connect } from 'react-redux';
import style from './style.module.scss';
import PropTypes from 'prop-types';
import { Bounce, Zoom } from 'react-reveal';
import { toggleContact } from '../../state/actions';
import ButtonPrimary from '../ButtonPrimary';
import BimboEatingCookie from '../../images/landing_page/bimbo_eating_cookie.png';


const ReachOutCTA = (props) => {
  const { backgroundColor, onClickCTA, backgroundImage, backgroundSize } = props;
  const handleContactClick = (e) => {
    props.dispatch(toggleContact(true, 'bimbo'))
  }

  return (
    <section style={{ backgroundImage: backgroundImage ? `url(${backgroundImage})` : null, backgroundSize: backgroundSize ? `${backgroundSize}` : 'contain' }} className={`${style.reachOutSection} ${backgroundColor ? style[`${backgroundColor}`] : null}`}>
      <Bounce top>   <span className={style.reachOutSectionTitle}>REACH OUT TO US!</span></Bounce>
      <Zoom>
        <p className={style.reachOutSectionText}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        <br />
        Sed do eiusmod tempor incididunt ut labore et dolore.
      </p>
      </Zoom>
      <Bounce bottom>
        <ButtonPrimary
          label="CONTACT US"
          type="blue"
          size="small"
          onClick={handleContactClick}>
        </ButtonPrimary>
      </Bounce>
      <Bounce right>
        <img className={style.bimboEatingCookie} src={BimboEatingCookie} alt="Bimbo eating cookie" />
      </Bounce>
    </section>
  );
};

ReachOutCTA.defaultProps = {
  backgroundImage: null,
  backgroundSize: 'contain'
};

ButtonPrimary.propTypes = {
  backgroundImage: PropTypes.string,
  backgroundSize: PropTypes.string
}

export default connect()(ReachOutCTA);
